import axiosInstance from "@/axios";

const sendMessageOnOrderedCall = (mailData) =>
  axiosInstance.post("/v1/notification/message", mailData);

const sendMessageOnGetToKnowBetter = (data) =>
  axiosInstance.post("/v1/notification/message/get-to-know-better", data);

export { sendMessageOnOrderedCall, sendMessageOnGetToKnowBetter };
